import Dashboard from "components/dashboard/dashboard";
import { ROUTES } from "constants/routes";
import { MODELS_PAGE_LINK_TEST_ID } from "constants/test";
import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

interface DashboardPageProps {}

const DashboardPage: FunctionComponent<DashboardPageProps> = () => {
  return (
    <Dashboard
      links={[
        {
          label: "Configurators",
          path: ROUTES.configurators,
          testId: "",
          isSelected: (path) => path === ROUTES.configurators || path.startsWith("/configurators"),
        },
        { label: "Models", path: ROUTES.models, testId: MODELS_PAGE_LINK_TEST_ID },
        { label: "Materials", path: ROUTES.materials, testId: "" },
      ]}
    >
      <Outlet />
    </Dashboard>
  );
};

export default DashboardPage;
